import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface EmissionFactorState {
    emissionFactors: any[];
    loading: boolean;
    error: string | null;
}

const initialState: EmissionFactorState = {
    emissionFactors: [],
    loading: false,
    error: null,
};

const emissionFactorSlice = createSlice({
    name: 'emissionFactor',
    initialState,
    reducers: {
        setEmissionFactors: (state, action: PayloadAction<any[]>) => {
            state.emissionFactors = action.payload;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
        },
    },
});

export const { setEmissionFactors, setLoading, setError } = emissionFactorSlice.actions;
export default emissionFactorSlice.reducer;

export const selectAllEmissionFactors = (state: any) => state.emissionFactor.emissionFactors;
